import axios from 'axios';

const state = {
    invoices: [],
    account: {}
}

const getters = {
    getInvoices: state => state.invoices,
    getAccount: state => state.account
}

const actions = {
    async fetchInvoices({ commit }) {
        await axios.get('/api/invoice')
            .then((response) => {
                commit('setInvoices', response.data)
                return Promise.resolve();
            })
            .catch((error) => {
                commit('setInvoices', [])
                return Promise.reject(error)
            })
    },
    async fetchAccount({ commit }) {
        await axios.get('/api/account')
            .then((response) => {
                commit('setAccount', response.data)
                return Promise.resolve();
            })
            .catch((error) => {
                commit('setAccount', {})
                return Promise.reject(error)
            })
    },
    async updateAccount({ commit }, account) {
        await axios.put('/api/account', account)
            .then((response) => {
                commit('setAccount', response.data)
                commit('setAccountSettings', response.data.accountSettings) // UI Search gets list settings from appConfig, so set any updates here
                return Promise.resolve();
            })
            .catch((error) => {
                commit('setAccount', {})
                return Promise.reject(error)
            })
    },
    async updatePaymentMethod({ commit }, paymentMethod) {
        return new Promise((resolve, reject) => {
            axios.post('/api/account/payment', paymentMethod)
            .then((response) => {
                commit('setPaymentMethod', response.data)
                resolve(response.data);
            })
            .catch((error) => {
                reject(error)
            })
        });
    },
    async updateSubscription({ commit }, subscription) {
        await axios.post('/api/account/subscription', subscription)
            .then((response) => {
                commit('setSubscription', response.data)
                return Promise.resolve();
            })
            .catch((error) => {
                return Promise.reject(error)
            })
    }
}

// TODO setSubscription can be removed as it is no longer used. Will be returning list of subscription items in the future
const mutations = {
    setInvoices: (state, invoices) => (state.invoices = invoices),
    setAccount: (state, account) => (state.account = account),
    setPaymentMethod: (state, paymentMethod) => {
        state.account.cardType = paymentMethod.cardType
        state.account.cardExpiration = paymentMethod.cardExpiration
        state.account.cardLast4 = paymentMethod.cardLast4
    },
    setSubscription: (state, subscription) => {
        state.account.subscription = subscription.subscription
        state.account.subTitle = subscription.subTitle
        state.account.subDescription = subscription.subDescription
        state.account.subPaid = subscription.subPaid
        state.account.subInvoiceStart = subscription.subInvoiceStart
        state.account.subInvoiceEnd = subscription.subInvoiceEnd
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}